import { Routes } from '@angular/router';
import { AuthGuard, NoAuthGuard } from './core/auth-guard/auth.guard';
import { unsavedChangesGuard } from './core/unsaved/unsaved-changes.guard';
import { ServerErrorGuard } from './core/auth-guard/serverError/server-error-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
    title: 'Sign In - GMEX',
  },
  {
    path: 'invite/:inviteId',
    loadComponent: () =>
      import('./shared/authontication/invite/invite').then(m => m.Invite),
    title: 'Accept Invite - GMEX',
  },
  {
    path: 'signin',
    loadComponent: () =>
      import('./shared/authontication/authorization/authorization.component').then(m => m.AuthorizationComponent),
    canActivate: [NoAuthGuard],
    title: 'Sign In - GMEX',
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./shared/authontication/authorization/authorization.component').then(m => m.AuthorizationComponent),
    canActivate: [NoAuthGuard],
    title: 'Create Account - GMEX',
  },
  {
    path: 'forgot',
    loadComponent: () =>
      import('./shared/authontication/forgot/forgot.component').then(m => m.ForgotComponent),
    title: 'Forgot Password - GMEX',
  },
  {
    path: 'gmex',
    loadComponent: () =>
      import('./shared/layout/main/main.component').then(m => m.MainComponent),
    canActivate: [AuthGuard],
    title: 'Seller - GMEX',
    children: [
      // {
      //   path: '',
      //   redirectTo: 'dashboard',
      //   pathMatch: 'full',
      // },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./module/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Dashboard' },
      },
      {
        path: 'main-moq',
        loadComponent: () =>
          import('./module/main-moq/main-moq.component').then(m => m.MainMoqComponent),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'MOQ' },
      },
      {
        path: 'mainBuyer',
        loadComponent: () =>
          import('./module/main-buyers/main-buyers.component').then(m => m.MainBuyersComponent),
        canActivate: [AuthGuard],
        title: 'Seller - GMEX',
        data: { breadcrumb: 'Seller - GMEX' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./module/main-buyers/buyers-quote/buyers-quote.component').then(m => m.BuyersQuoteComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Quote List' },
          },
          {
            path: 'buyerslist',
            loadComponent: () =>
              import('./module/main-buyers/buyers-quote/buyers-quote.component').then(m => m.BuyersQuoteComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Quote List' },
          },
          {
            path: 'manageQuote/:quoteId',
            loadComponent: () =>
              import('./module/main-buyers/manage-quotes/manage-quotes.component').then(m => m.ManageQuotesComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Manage Quote' },
            canDeactivate: [unsavedChangesGuard],
          },
        ],
      },
      {
        path: 'main-sales',
        loadComponent: () => import('./module/main-sales/main-sales.component').then(m => m.MainSalesComponent),
        title: 'Seller - GMEX',
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Sales Orders' },
        children: [
          {
            path: '',
            loadComponent: () => import('./module/main-sales/list/list.component').then(m => m.ListComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Sales Orders' },
          },
          {
            path: 'list',
            loadComponent: () => import('./module/main-sales/list/list.component').then(m => m.ListComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Sales Orders' },
          },
          {
            path: 'purchaseView/:purchaseId',
            loadComponent: () => import('./module/main-sales/purchase-detail/purchase-detail.component').then(m => m.PurchaseDetailComponent),
            canActivate: [AuthGuard],
            title: 'Seller - GMEX',
            data: { breadcrumb: 'Purchase List' },
          },
        ]
      },
      {
        path: 'packaging-slip',
        loadComponent: () => import('./module/packaging-slip/packaging-slip.component').then(m => m.PackagingSlipComponent),
        title: 'Seller - GMEX',
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Manage Quote' },
        children: [
          {
            path: '',
            loadComponent: () => import('./module/packaging-slip/list/list.component').then(m => m.ListComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Shipment' },
          },
          {
            path: 'list',
            loadComponent: () => import('./module/packaging-slip/list/list.component').then(m => m.ListComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Shipment' },
          },
          {
            path: 'createView/:purchaseId',
            loadComponent: () => import('./module/packaging-slip/create-packaging-slip/create-packaging-slip.component').then(m => m.CreatePackagingSlipComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Shipment' },
          },
          {
            path: 'previewSlip/:slipId',
            loadComponent: () => import('./module/packaging-slip/genrate-slip/genrate-slip.component').then(m => m.GenrateSlipComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Shipment' },
          },
          {
            path: 'previewSlip',
            loadComponent: () => import('./module/packaging-slip/genrate-slip/genrate-slip.component').then(m => m.GenrateSlipComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Shipment' },
          },
        ]
      },
      {
        path: 'commission',
        loadComponent: () => import('./module/commission/commission.component').then(m => m.CommissionComponent),
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Platform Fee' },
        children: [
          {
            path: '',
            loadComponent: () => import('./module/commission/list/list.component').then(m => m.ListComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Platform Fee' },
          },
          {
            path: 'po/:purchaseId',
            loadComponent: () => import('./module/commission/po/po.component').then(m => m.PoComponent),
            canActivate: [AuthGuard],
            data: { breadcrumb: 'Platform Fee Invoice' },
          }
        ]
      },
      {
        path: 'help-center',
        loadComponent: () =>
          import('./module/help-center/help-center/help-center.component').then(m => m.HelpCenterComponent),
        title: 'Help-Center - GMEX',
        data: { breadcrumb: 'Help-Center' },
      },
      {
        path: 'main-settings',
        loadComponent: () =>
          import('./module/main-setting/main-setting.component').then(m => m.MainSettingComponent),
        title: 'Seller - GMEX',
        data: { breadcrumb: 'Settings' },
        children: [
          {
            path: '',
            redirectTo: 'OrgProfile',
            pathMatch: 'full',
          },
          {
            path: 'OrgProfile',
            loadComponent: () =>
              import('./module/main-setting/organization/profile/profile.component').then(m => m.ProfileComponent),
            data: { breadcrumb: 'Organization Profile' },
            canDeactivate: [unsavedChangesGuard],

          },
          {
            path: 'warehouse',
            loadComponent: () =>
              import('./module/main-setting/organization/warehouse/warehouse.component').then(m => m.WarehouseComponent),
            data: { breadcrumb: 'Warehouse' },
          },
          {
            path: 'branding',
            loadComponent: () =>
              import('./module/main-setting/organization/branding/branding.component').then(m => m.BrandingComponent),
            data: { breadcrumb: 'Branding' },
          },
          {
            path: 'certification',
            loadComponent: () =>
              import('./module/main-setting/organization/certification/view/view.component').then(m => m.ViewComponent),
            data: { breadcrumb: 'Certification' },
          },
          {
            path: 'accountprofile',
            loadComponent: () =>
              import('./module/main-setting/account/profile/profile.component').then(m => m.ProfileComponent),
            data: { breadcrumb: 'Account Profile' },
          },
          {
            path: 'password',
            loadComponent: () =>
              import('./module/main-setting/account/password/password.component').then(m => m.PasswordComponent),
            data: { breadcrumb: 'Password' },
          },
          {
            path: 'rates',
            loadComponent: () =>
              import('./module/main-setting/taxes-compliance/tax-rates/view-taxes/view-taxes.component').then(m => m.ViewTaxesComponent),
            data: { breadcrumb: 'Tax Rates' },
          },
          {
            path: 'gst',
            loadComponent: () =>
              import('./module/main-setting/taxes-compliance/gst-verification/gst-verification.component').then(m => m.GstVerificationComponent),
            data: { breadcrumb: 'GST Settings' },
          },
          {
            path: 'users',
            loadComponent: () =>
              import('./module/main-setting/users-roles/users/views/views.component').then(m => m.ViewsComponent),
            data: { breadcrumb: 'Users' },
          },
          {
            path: 'roles',
            loadComponent: () =>
              import('./module/main-setting/users-roles/roles/views/views.component').then(m => m.ViewsComponent),
            data: { breadcrumb: 'Roles' },
          },
          {
            path: 'emails',
            loadComponent: () =>
              import('./module/main-setting/reminders-notifications/email/email.component').then(m => m.EmailComponent),
            data: { breadcrumb: 'Emails' },
          },
          // {
          //   path: 'sms',
          //   loadComponent: () =>
          //     import('./module/main-setting/sms/sms.component').then(m => m.SmsComponent),
          //   data: { breadcrumb: 'SMS' },
          // },
          {
            path: 'dateTimeZone',
            loadComponent: () =>
              import('./module/main-setting/setting/system-settings/system-settings.component').then(m => m.SystemSettingsComponent),
            data: { breadcrumb: 'Date & Time zone' },
          },
          {
            path: 'uomSettings',
            loadComponent: () =>
              import('./module/main-setting/setting/uom-settings/uom-settings.component').then(m => m.UomSettingsComponent),
            data: { breadcrumb: 'UOM Settings' },
          },
          {
            path: 'notifications',
            loadComponent: () =>
              import('./module/main-setting/reminders-notifications/notifications/notifications.component').then(m => m.NotificationsComponent),
            data: { breadcrumb: 'Notifications ' },
            // canDeactivate: [UnsavedChangesGuard],
          },
        ],
      },
      {
        path: 'dsa-configuration',
        loadComponent: () =>
          import('./module/dsa/configuration/configuration').then(m => m.DsaConfigComponent),
        title: 'DSA Configuration - GMEX',
        data: { breadcrumb: 'DSA Configuration' },
      },
      {
        path: 'catalogue',
        canActivate: [AuthGuard],
        data: { breadcrumb: 'Catalogue' },
        children: [
          {
            path: '', pathMatch: 'full',
            loadComponent: () => import('./module/catalogue/catalogue-list/catalogue-list').then(m => m.CatalogueList),
            title: 'Catalogue - GMEX',
          },
          {
            path: 'excel-ext',
            loadComponent: () => import('./module/catalogue/excel-ext/excel-ext').then(m => m.ExcelExt),
            title: 'Import Catalogue - GMEX',
            data: { breadcrumb: 'Import Excel' },
          },
        ],
      },
    ],
  },

  {
    path: 'server-error',
    loadComponent: () =>
      import('./shared/server-error/server-error')
        .then(m => m.ServerError),
    canActivate: [ServerErrorGuard]
  },
  {
    path: '**',
    redirectTo: 'signin',
    title: 'Redirect - GMEX',
  },
];
